<template>
  <div class="business">
    <div id="heading">
      <div class="header-icon fa fa-building"></div>
      <h1>Commercial Insurance for Your Business</h1>
    </div>
    <section id="main" class="wrapper">
      <div class="inner">
        <div class="content">
          <div class="text-center">
            <h2>Protect your Investment</h2>
          </div>

          <p>No matter what business you’re in, each workday is dedicated to doing your job well and providing your
            customers with the best service possible. SIG & Associates would like to return the favor by giving you the
            coverage you need to ensure the security of your business.</p>
          <p>At SIG & Associates, we’re committed to keeping your business protected – so you can focus on your
            day-to-day operations. And with the right insurance plan, your business will be covered from top to
            bottom.</p>
          <p>We offer the following options for your business assets: </p>

          <ul>
            <li class="list-item link" @click="handleModal()" data-page="property">
              Commercial property insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="general">
              Commercial general liability
            </li>
            <li class="list-item link" @click="handleModal()" data-page="bop">
              Business owners policy (BOP)
            </li>
            <li class="list-item link" @click="handleModal()" data-page="marine">
              Inland marine insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="auto">
              Commercial auto insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="umbrella">
              Commercial umbrella insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="professional">
              Professional liability insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="workers">
              Workers compensation
            </li>
            <li class="list-item link" @click="handleModal()" data-page="crime">
              Crime insurance
            </li>
          </ul>

          <p><small><i>SIG & Associates provides insurance to businesses in Wichita Falls, Haslet, Decatur, Prosper,
            Vernon, Garland, and surrounding areas.</i></small></p>
        </div>
        <hr>
        <div class="content">
          <GetQuoteForm class="get-quote"/>
        </div>
        <hr>
      </div>
    </section>
    <modal v-if="showModal" @close="showModal = false" v-bind:header="modalHeader" v-bind:body="modalBody"/>
  </div>
</template>

<script>
import Vue from 'vue'

import Modal from '@/widgets/Modal'
import GetQuoteForm from '@/components/GetQuoteForm'

import businessHelper from '../helpers/businessHelper.js'

Object.defineProperty(Vue.prototype, '$businessHelper', {value: businessHelper})
Vue.component('modal')

export default {
  name: 'Business',
  methods: {
    handleModal: function () {
      let action = event.target.attributes['data-page'].value

      this.modalHeader = this.templates[action].header
      this.modalBody = this.templates[action].body

      this.showModal = true
    }
  },
  data: function () {
    return {
      showModal: false,
      modalHeader: '',
      modalBody: '',
      templates: this.$businessHelper
    }
  },
  components: {
    Modal,
    GetQuoteForm
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

.list-item.link {
  cursor: pointer;
  padding: 10px;
}

.list-item.link:hover {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/Business.vue